import Dexie, { type EntityTable } from 'dexie';
import type {
  Configuration,
  Device,
  DeviceStats,
  Driver,
  Landmark,
  LandmarkCategory,
  Location,
  SocketLocation,
  Territory,
  Unit,
  User,
} from './models';

interface EntitiesTable {
  _configuration: EntityTable<Configuration, 'uid'>;
  administrative_division: EntityTable<Territory, 'uid'>;
  device: EntityTable<Device, 'uid'>;
  devicestats: EntityTable<DeviceStats, 'uid_device'>;
  broker_device: EntityTable<SocketLocation, 'fk_device'>;
  driver: EntityTable<Driver, 'uid'>;
  location: EntityTable<Location, 'uid'>;
  poi_category: EntityTable<LandmarkCategory, 'uid'>;
  poi: EntityTable<Landmark, 'uid'>;
  service: EntityTable<Unit, 'uid'>;
  user: EntityTable<User, 'uid'>;
}

type AppDB = Dexie & EntitiesTable;

const db = new Dexie('UbiwanDB') as Dexie & EntitiesTable;

// const INDEXDB_VERSION = 1
db.version(1).stores({
  _configuration: '++uid, name',
  administrative_division: '++uid, code',
  broker_device: 'fk_device',
  device: '++uid',
  devicestats: 'uid_device',
  driver: '++uid, uid_parent, lastname, firstname',
  location: 'uid',
  poi_category: '++uid, uid_parent, label',
  poi: '++uid, uid_parent, label',
  service: '++uid, uid_parent, tag',
  user: '++uid, lastname',
});

async function restartDb() {
  await db.delete();
  await db.open();
}

async function resetDb() {
  await db.delete();
  await db.close();
}

export { db, resetDb, restartDb };
export type { AppDB, EntitiesTable };
